function activateTab(tab) {
  const tablist = tab.closest('[role="tablist"]');
  if (!tablist) return;

  const tabs = tablist.querySelectorAll('[role="tab"]');
  const panelId = tab.getAttribute("aria-controls");
  const panel = document.getElementById(panelId);

  tabs.forEach(node => {
    node.setAttribute("aria-selected", "false");
    node.setAttribute("tabindex", "-1");
    node.classList.remove("tab__current");
  });

  document.querySelectorAll(".card__content[role='tabpanel']").forEach(node => {
    node.hidden = true;
  });

  tab.setAttribute("aria-selected", "true");
  tab.setAttribute("tabindex", "0");
  tab.classList.add("tab__current");

  if (panel) {
    panel.hidden = false;
  }
}

function onTabKeydown(event) {
  const tab = event.currentTarget;
  const tablist = tab.closest('[role="tablist"]');
  if (!tablist) return;

  const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
  const index = tabs.indexOf(tab);
  let nextIndex = index;

  switch (event.key) {
    case "ArrowRight":
    case "ArrowDown":
      nextIndex = (index + 1) % tabs.length;
      event.preventDefault();
      break;
    case "ArrowLeft":
    case "ArrowUp":
      nextIndex = (index - 1 + tabs.length) % tabs.length;
      event.preventDefault();
      break;
    case "Home":
      nextIndex = 0;
      event.preventDefault();
      break;
    case "End":
      nextIndex = tabs.length - 1;
      event.preventDefault();
      break;
    default:
      return;
  }

  tabs[nextIndex].focus();
  activateTab(tabs[nextIndex]);
}

function initCertificateTabs() {
  document.querySelectorAll('[role="tablist"] .tab').forEach(tab => {
    tab.addEventListener("click", event => {
      event.preventDefault();
      activateTab(tab);
    });
    tab.addEventListener("keydown", onTabKeydown);
  });

  const firstTab = document.getElementById("tab-link-0");
  if (firstTab) {
    activateTab(firstTab);
  }
}

$(document).ready(function() {
  initCertificateTabs();
});

export { activateTab, initCertificateTabs };
